"use client";
import styles from './footer-dropdown.module.scss'
import {FaGlobeAmericas} from "@react-icons/all-files/fa/FaGlobeAmericas";
import {useAxios} from "hooks/useAxios";
import SmallSelect from "components/UI/SmallSelect/SmallSelect";

const FooterDropdown = ({country, countries, locale}) => {

    const getLangFromLocale = (locale) => {
        if (typeof locale !== 'string') return null;

        const parts = locale.split('-');
        return parts.length === 2 ? parts[0].toLowerCase() : null;
    };
    const {post} = useAxios()
    const handleChangeLand = (selectedCountry) => {
        const localeFull = `${getLangFromLocale(locale)}-${selectedCountry.naam}`;
        document.cookie = `NEXT_LOCALE=${encodeURIComponent(localeFull)}; Path=/; Max-Age=31536000; SameSite=Lax`;


        post(`${process.env.NEXT_PUBLIC_BACKEND}/api/land`, {'land_id': selectedCountry.id})
            .then(() => {
                // Get current path and replace locale slug with new one
                const currentPath = window.location.pathname;
                const currentLocaleMatch = currentPath.match(/^\/([a-z]{2}-[a-z]{2})(\/.*)?$/i);

                if (currentLocaleMatch) {
                    // Replace old locale with new locale in URL
                    const restOfPath = currentLocaleMatch[2] || '';
                    window.location.href = `/${localeFull}${restOfPath}`;
                } else {
                    // No locale in URL, just reload
                    location.reload();
                }
            });
    }

    const customStyles = {
        control: (base) => ({
            ...base,
            backgroundColor: 'transparent', // geen wit
            border: 'none',
            boxShadow: 'none',
            minHeight: 'unset',
            cursor: 'pointer',
        }),
        menu: (base) => ({
            ...base,
            backgroundColor: '#1b222b',
            color: 'white',
            borderRadius: '8px',
            overflow: 'hidden',
            minWidth: '150px',
            width: 'auto',
            whiteSpace: 'nowrap',
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused ? '#2b323c' : 'transparent',
            color: 'white',
            cursor: 'pointer',
        }),
        singleValue: (base) => ({
            ...base,
            color: 'white', // geselecteerde tekst wit
        }),
        indicatorSeparator: () => ({
            display: 'none', // scheidingslijn weg
        }),
        dropdownIndicator: (base) => ({
            ...base,
            color: 'white',
            padding: 0,
        }),
        valueContainer: (base) => ({
            ...base,
            padding: 0,
        }),
        input: (base) => ({
            ...base,
            color: 'white',
        }),
    };
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <FaGlobeAmericas className={styles.globeIcon}/>
            <SmallSelect
                //className={styles.customDropdown}
                styles={customStyles}
                value={country}
                options={countries}
                getOptionValue={option => option.id}
                getOptionLabel={option => `${option.fullname}`}
                onChange={(selected) => handleChangeLand(selected)}
                formatOptionLabel={(option, { context }) =>
                    context === 'menu' ? option.fullname : option.naam
                }
            />
        </div>

    //     <Dropdown className={`${style.landen} mt-3`}>
    //     <Dropdown.Toggle variant="Secondary" id="dropdown-basic" className={'pl-0'}>
    //         { country?.naam } <FaGlobeAmericas style={{margin: '0 4px 4px 4px'}} />
    //     </Dropdown.Toggle>
    //
    //     <Dropdown.Menu>
    //         { countries?.map(x => <Dropdown.Item key={`landdrpdwn_${x.id}`} active={country?.id === x.id}
    //                                           onClick={() => handleChangeLand(x.id)}
    //                                           className={style.landItem} eventKey={x.id}>{x.naam}</Dropdown.Item>)}
    //     </Dropdown.Menu>
    // </Dropdown>
)
}

export default FooterDropdown